import { useState } from "react";
import {
  UsersGetConnectLwaStatusPostRequest,
  UsersApi,
  RequestGetConnectLwasStautsRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetConnectLwaStatus = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getConnectLwaStatus = async (
    req: RequestGetConnectLwasStautsRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersGetConnectLwaStatusPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersGetConnectLwaStatusPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("LWA連携状態フラグの取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { getConnectLwaStatus, result, error, isLoading };
};
